import { formatNumber } from "./number";
import { CURRENCY_SYMBOLS } from "./currencymap";

export function formatCurrency(value, decimal, locale) {
  if (!value) return null;
  const [currencyValue, currencyCode] = value.split(" ");
  return `${CURRENCY_SYMBOLS[currencyCode || "USD"] || ""}${formatNumber(
    currencyValue,
    decimal,
    locale
  )}`;
}
